<template>
	<div>
		<el-row :gutter="10">
			<!-- 左边 -->
			<el-col :xs="0" :sm="15" :md="15" :lg="15" :xl="15" :offset="2">
			  <div class="grid-content left">
				  <div class="position">
					<el-breadcrumb separator-class="el-icon-d-arrow-right">
					  <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
					  <el-breadcrumb-item :to="{ path: '/list/id/2' }" v-if="content.typelist == 0" style="cursor: pointer;">招标公告</el-breadcrumb-item>
					  <el-breadcrumb-item :to="{ path: '/list/id/4' }" v-else="content.typelist == 1" style="cursor: pointer;">散单需求</el-breadcrumb-item>
					  <el-breadcrumb-item>{{content.title}}</el-breadcrumb-item>
					</el-breadcrumb>  
				  </div>
				  <div class="content" id="details">
					  <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
						<div class="title">{{content.title}}</div>
						<div class="subtitle">
							<span>
								<i class="el-icon-map-location"></i>{{content.province_id}}
							</span>
							<span>
								<i class="el-icon-connection"></i>状态：{{status(content.status)}}
							</span>
							<span style="cursor: pointer;">
								<i class="el-icon-star-off"></i>加入收藏
							</span>
							<span v-print="'#details'" style="cursor: pointer;">
								<i class="el-icon-printer"></i>打印
							</span>
							<span style="cursor: pointer;">
								<i class="el-icon-download"></i>下载
							</span>
						</div>
						<div class="description">
							<table cellspacing="0" cellpadding="0" width="100%">
								<tbody>
									<tr>
										<td>更新时间：</td>
										<td>{{$utils.timestampToTimes(content.updatetime*1000)}}</td>
									</tr>
									<!-- <tr> -->
										<!-- <td>招标文件：</td> -->
										<!-- <td v-if="(!isMember && !isBuy) || !isLogin">您暂无下载权限</td>
										<td v-if="isMember || isBuy"><a :href="content.file">点击下载</a></td> -->
										<!-- <td v-if="content.permissions == 0"><a :href="'http://backend.hrl56.com' + content.file">点击下载</a></td>
										<td v-else-if="content.permissions == 1 && isLogin"><a :href="'http://backend.hrl56.com' + content.file">点击下载</a></td>
										<td v-else-if="content.permissions == 2 && (isMember || isBuy)"><a :href="'http://backend.hrl56.com' + content.file">点击下载</a></td>
										<td v-else>您暂无下载权限</td>
									</tr> -->
									<tr>
										<td>会员状态：</td>
										<td v-if="!isLogin">您还没有登录，请<span @click="login = true" style="padding:0 10px;color:#02A0EA;cursor: pointer;">登录</span>后查看详情,如果还不是会员,立即<span style="padding:0 10px;color:#02A0EA;cursor: pointer;" @click="$router.push('/register')">免费注册</span></td>
										<td v-if="isLogin && ( !isMember && !isBuy)">您现在的会员级别是{{memberType(member)}}，查看当前信息请升级为VIP会员</td>
										<td v-if="isMember || isBuy ">您现在的会员级别是<span style="color: #c20d24;">{{memberType(member)}}</span> </td>
									</tr>
								</tbody>
							</table>
						</div>
						<div class="details" v-html="content.description"></div>
						
						<div v-if="!isLogin && content.permissions != 0" style="text-align: center; margin: 50px auto;">
							<div style="margin:30px auto;color: #606266;">招标详细内容仅对vip会员开放，登录后可查看全文</div>
							<div>
								<el-button type="primary" @click="login = true">登录</el-button>
								<el-button type="danger" @click="$router.push('/register')">免费注册</el-button>
							</div>
							<div style="margin:30px auto;color: #606266;">非vip会员可登录后扫码支付进行单条查看</div>
						</div>
						<div v-if="isLogin && !isMember && !isBuy && content.permissions == 2" style="text-align: center; margin:50px auto;color: #606266;">
							<div>您现在的会员级别是{{memberType(member)}}，查看信息请升级为vip会员</div>
							<div>
								<div style="margin-top: 10px;font-weight: bold;font-size: 10px;">仅查看当前文章</div>
								<div :class="flag==1?'active':'price'" @click="choose(1,articlePrice)">
									<div>单条</div>
									<div style="margin:25px auto;border-bottom: 1px solid #DCDFE6;font-size: 30px; color: #F56C6C;padding-bottom: 5px;"><span style="font-size: 20px;">￥</span>{{articlePrice}}</div>
									<div style="font-size: 15px; color: #c20d24;">超值体验</div>
								</div>
							</div>
							<div>
								<div style="margin-top: 10px;font-weight: bold;font-size: 10px;line-height: 20px;display: flex;align-items: center;justify-content:center;"> <img src="/images/zuan.png" alt="" width="20px" style="display: block;"> <span style="display: block;">开通全网vip会员</span></div>
								<div style="display: flex;">
									<div :class="flag==2?'active':'price'" @click="choose(2,onePrice)">
										<div>一个月</div>
										<div style="margin:25px auto;border-bottom: 1px solid #DCDFE6;font-size: 30px; color: #F56C6C;padding-bottom: 5px;"><span style="font-size: 20px;">￥</span>{{onePrice}}</div>
										<div style="font-size: 15px; color: #c20d24;">原价：{{onePriceYuan}}元</div>
									</div>
									<div :class="flag==3?'active':'price'" @click="choose(3,threePrice)">
										<div>三个月</div>
										<div style="margin:25px auto;border-bottom: 1px solid #DCDFE6;font-size: 30px; color: #F56C6C;padding-bottom: 5px;"><span style="font-size: 20px;">￥</span>{{threePrice}}</div>
										<div style="font-size: 15px; color: #c20d24;">原价：{{threePriceYuan}}元</div>
									</div>
									<div :class="flag==4?'active':'price'" @click="choose(4,sixPrice)">
										<div>六个月</div>
										<div style="margin:25px auto;border-bottom: 1px solid #DCDFE6;font-size: 30px; color: #F56C6C;padding-bottom: 5px;"><span style="font-size: 20px;">￥</span>{{sixPrice}}</div>
										<div style="font-size: 15px; color: #c20d24;">原价：{{sixPriceYuan}}元</div>
									</div>
									<div :class="flag==5?'active':'price'" @click="choose(5,yearPrice)">
										<div>一年</div>
										<div style="margin:25px auto;border-bottom: 1px solid #DCDFE6;font-size: 30px; color: #F56C6C;padding-bottom: 5px;"><span style="font-size: 20px;">￥</span>{{yearPrice}}</div>
										<div style="font-size: 15px; color: #c20d24;">原价：{{yearPriceYuan}}元</div>
									</div>
								</div>
								<div style="font-size: 20px;">应付金额：{{this.price}}元</div>
								<div style="margin: 30px auto;">
									<el-button style="background-color: #31ae37;border-color:#31ae37;color: #fff;" @click="toPay('wechat','scan')"> 
									<img style="display: block;" src="/images/wx.png" width="50px" height="50px"> 
									<span style="display: block;">微信支付</span> </el-button>
									<el-button style="background-color: #24a3de;border-color:#24a3de;color: #fff;" @click="toPay('alipay','web')">
										<img style="display: block;margin:auto" src="/images/alipay.png" width="50px" height="50px">
										<span style="display: block;">支付宝支付</span> </el-button>
									</el-button>
								</div>
							</div>
						</div>
						<div class="details" v-html="content.content" v-if="(content.permissions == 0 || isLogin) && (isMember || isBuy || content.permissions < 2)"></div>
						<div class="description">
							<table cellspacing="0" cellpadding="0" width="100%">
								<tbody>
									<tr>
										<td>更新时间：</td>
										<td>{{$utils.timestampToTimes(content.updatetime*1000)}}</td>
									</tr>
									<!-- <tr>
										<td>招标文件：</td> -->
										<!-- <td v-if="(!isMember && !isBuy) || !isLogin">您暂无下载权限</td>
										<td v-if="isMember || isBuy"><a :href="content.file">点击下载</a></td> -->
										<!-- <td v-if="content.permissions == 0"><a :href="'http://backend.hrl56.com' + content.file">点击下载</a></td>
										<td v-else-if="content.permissions == 1 && isLogin"><a :href="'http://backend.hrl56.com' + content.file">点击下载</a></td>
										<td v-else-if="content.permissions == 2 && (isMember || isBuy)"><a :href="'http://backend.hrl56.com' + content.file">点击下载</a></td>
										<td v-else>您暂无下载权限</td>
									</tr> -->
									<tr>
										<td>会员状态：</td>
										<td v-if="!isLogin">您还没有登录，请<span @click="login = true" style="padding:0 10px;color:#02A0EA;cursor: pointer;">登录</span>后查看详情,如果还不是会员,立即<span style="padding:0 10px;color:#02A0EA;cursor: pointer;" @click="$router.push('/register')">免费注册</span></td>
										<td v-if="isLogin && ( !isMember && !isBuy)">您现在的会员级别是{{memberType(member)}}，查看当前信息请升级为VIP会员</td>
										<td v-if="isMember || isBuy ">您现在的会员级别是<span style="color: #c20d24;">{{memberType(member)}}</span> </td>
									</tr>
								</tbody>
							</table>
						</div>
						<div class="tips"><span>【友情提示】</span>单篇文章扫码付款后，请按F5刷新，招标公告显示。为保证您能够顺利投标，请在投标或购买招标文件前向招标人或招标代理机构咨询投标详细要求，具体要求及项目情况以招标人或招标代理机构的解释为准。</div>
					</el-col>
				  </div>
			  </div>
			</el-col>
			<!-- 登录 -->
			<el-dialog title="登录" :visible.sync="login" width="350px">
			  <el-form :model="loginForm">
			    <el-form-item label="账号" :label-width="formLabelWidth">
			      <el-input v-model="loginForm.username" autocomplete="off" placeholder="请输入账号"></el-input>
			    </el-form-item>
				<el-form-item label="密码" :label-width="formLabelWidth">
				  <el-input v-model="loginForm.password" type="password" autocomplete="off" placeholder="请输入密码"></el-input>
				</el-form-item>
			  </el-form>
			  <div slot="footer" class="dialog-footer">
			    <el-button @click="login = false">取 消</el-button>
			    <el-button type="primary" @click="toLogin">确 定</el-button>
			  </div>
			</el-dialog>
			<!-- 注册 -->
<!-- 			<el-dialog title="注册" :visible.sync="register" width="60%">
			  <el-form :model="registerForm" :rules="rules" ref="registerForm">
				<el-form-item label="公司名称" prop="company" :label-width="registerformLabelWidth">
				  <el-input v-model="registerForm.company" autocomplete="off" placeholder="请输入公司名称"></el-input>
				</el-form-item>
				<el-form-item label="联系人" prop="nickname" :label-width="registerformLabelWidth">
				  <el-input v-model="registerForm.nickname" autocomplete="off" placeholder="请输入联系人"></el-input>
				</el-form-item>
				<el-form-item label="职务" prop="duties" :label-width="registerformLabelWidth">
				  <el-input v-model="registerForm.duties" autocomplete="off" placeholder="请输入职务"></el-input>
				</el-form-item>
				<el-form-item label="邮箱" prop="email" :label-width="registerformLabelWidth">
				  <el-input v-model="registerForm.email" autocomplete="off" placeholder="请输入邮箱"></el-input>
				</el-form-item>
				<el-form-item label="手机" prop="mobile" :label-width="registerformLabelWidth">
				  <el-input v-model="registerForm.mobile" autocomplete="off" placeholder="请输入手机"></el-input>
				</el-form-item>
			    <el-form-item label="账号" prop="username" :label-width="registerformLabelWidth">
			      <el-input v-model="registerForm.username" autocomplete="off" placeholder="请输入账号"></el-input>
			    </el-form-item>
				<el-form-item label="密码" prop="password" :label-width="registerformLabelWidth">
				  <el-input v-model="registerForm.password" type="password" autocomplete="off" placeholder="请输入密码"></el-input>
				</el-form-item>
			  </el-form>
			  <div slot="footer" class="dialog-footer">
			    <el-button @click="register = false">取 消</el-button>
			    <el-button type="primary" @click="toRegister('registerForm')">确 定</el-button>
			  </div>
			</el-dialog> -->
			<!-- 支付二维码弹出 -->
			<el-dialog
			  title="扫码支付"
			  :visible.sync="pay"
			  width="30%">
			  <span> <img :src="payurl" alt="" style="display: block;margin:auto"> </span>
			  <span slot="footer" class="dialog-footer">
			    <el-button type="primary" @click="pay = false">确 定</el-button>
			  </span>
			</el-dialog>
			<!-- 右边 -->
			<el-col :xs="0" :sm="5" :md="5" :lg="5" :xl="5">
				<div class="grid-content first">
					<el-carousel :interval="6000" arrow="never">
						<el-carousel-item v-for="item in bannerTop" :key="item.Id">
							<el-image :src="domain + item.image" fit='fill' style='width:100%;height:100%'></el-image>
						</el-carousel-item>
					</el-carousel>
				</div>
				<div class="grid-content second">
					<div class="listHeader">
						采购中心
					</div>
					<el-card class="box-card">
					  <div v-for="o in caigoulist.slice(0,4)" :key="o.Id" class="text item" @click="handle(o.Id)">
						{{o.title.substring(0,18)}}
					  </div>
					</el-card>  
				</div>
				<div class="grid-content third">
					<el-carousel :interval="5000" arrow="never">
						<el-carousel-item v-for="item in bannerMiddle" :key="item.Id">
							<el-image :src="domain + item.image" fit='fill' style='width:100%;height:100%'></el-image>
						</el-carousel-item>
					</el-carousel>
				</div>
				<div class="grid-content four">
					<div class="listHeader">
						散单需求
					</div>
					<el-card class="box-card">
					  <div v-for="o in sandanlist.slice(0,4)" :key="o.Id" class="text item" @click="handle(o.Id)">
						{{o.title.substring(0,18)}}
					  </div>
					</el-card>    
				</div>
			</el-col>
		</el-row>
		<!-- 手机端 -->
		<el-row>
			<el-col :xs="24" :sm="0" :md="0" :lg="0" :xl="0">
				<div class="mobile-title">
					{{content.title}}
				</div>
				<div class="mobile-info">
					<i class="el-icon-location-outline"></i>{{content.province_id}} 
					<i class="el-icon-price-tag" style="padding-left: 5px;"></i>{{type(content.typelist)}} 
					<i class="el-icon-star-off" style="padding-left: 5px;"></i>{{status(content.status)}}
				</div>
				<div class="mobile-time">
					<div class="mobile-starttime">
						<i class="el-icon-time" style="padding-left: 5px;"></i>开始日期：{{$utils.timestampToTimes(content.starttime*1000)}}
						</div>
					<div class="mobile-endtime">
						<i class="el-icon-time" style="padding-left: 5px;"></i>结束日期：{{$utils.timestampToTimes(content.endtime*1000)}}
						</div>
				</div>
<!-- 				<div class="mobile-file" v-if="!isLogin || (!isMember && !isBuy)">
					招标文件：暂无下载权限
				</div>
				<div class="mobile-file" v-if="isLogin && (isMember || isBuy)">
					招标文件：<a :href="content.file">点击下载</a>
				</div> -->
				<div class="mobile-file" v-if="content.permissions == 0"><a :href="'http://backend.hrl56.com' + content.file">点击下载</a></div>
				<div class="mobile-file" v-else-if="content.permissions == 1 && isLogin"><a :href="'http://backend.hrl56.com' + content.file">点击下载</a></div>
				<div class="mobile-file" v-else-if="content.permissions == 2 && (isMember || isBuy)"><a :href="'http://backend.hrl56.com' + content.file">点击下载</a></div>
				<div class="mobile-file" v-else>您暂无下载权限</div>
				<div class="mobile-description" v-html="content.description">
					摘要
				</div>
				<div v-if="!isLogin && content.permissions != 0" style="text-align: center; margin: 50px auto;">
					<div style="margin:30px auto;color: #606266;">招标详细内容仅对vip会员开放，登录后可查看全文</div>
					<div>
						<el-button type="primary" @click="login = true">登录</el-button>
						<el-button type="danger" @click="$router.push('/register')">免费注册</el-button>
					</div>
					<div style="margin:30px auto;color: #606266;">非vip会员可登录后扫码支付进行单条查看</div>
				</div>
				<div v-if="isLogin && !isMember && !isBuy && content.permissions == 2" style="text-align: center; margin:50px auto;color: #606266;">
					<div>您现在的会员级别是{{memberType(member)}}，查看信息请升级为vip会员</div>
					<div>
						<div style="margin-top: 10px;font-weight: bold;font-size: 10px;">仅查看当前文章</div>
						<div :class="flag==1?'active':'price'" @click="choose(1,articlePrice)" style="width:50%">
							<div>单条</div>
							<div style="margin:25px auto;border-bottom: 1px solid #DCDFE6;font-size: 30px; color: #F56C6C;padding-bottom: 5px;"><span style="font-size: 20px;">￥</span>{{articlePrice}}</div>
							<div style="font-size: 15px; color: #c20d24;">超值体验</div>
						</div>
					</div>
					<div>
						<div style="margin-top: 10px;font-weight: bold;font-size: 10px;line-height: 20px;display: flex;align-items: center;justify-content:center;"> <img src="/images/zuan.png" alt="" width="20px" style="display: block;"> <span style="display: block;">开通全网vip会员</span></div>
						<div style="display: flex;flex-wrap: wrap;">
							<div :class="flag==2?'active':'price'" @click="choose(2,onePrice)" style="width:40%">
								<div>一个月</div>
								<div style="margin:25px auto;border-bottom: 1px solid #DCDFE6;font-size: 30px; color: #F56C6C;padding-bottom: 5px;"><span style="font-size: 20px;">￥</span>{{onePrice}}</div>
								<div style="font-size: 13px; color: #c20d24;">原价：{{onePriceYuan}}元</div>
							</div>
							<div :class="flag==3?'active':'price'" @click="choose(3,threePrice)" style="width:40%">
								<div>三个月</div>
								<div style="margin:25px auto;border-bottom: 1px solid #DCDFE6;font-size: 30px; color: #F56C6C;padding-bottom: 5px;"><span style="font-size: 20px;">￥</span>{{threePrice}}</div>
								<div style="font-size: 13px; color: #c20d24;">原价：{{threePriceYuan}}元</div>
							</div>
							<div :class="flag==4?'active':'price'" @click="choose(4,sixPrice)" style="width:40%">
								<div>六个月</div>
								<div style="margin:25px auto;border-bottom: 1px solid #DCDFE6;font-size: 30px; color: #F56C6C;padding-bottom: 5px;"><span style="font-size: 20px;">￥</span>{{sixPrice}}</div>
								<div style="font-size: 13px; color: #c20d24;">原价：{{sixPriceYuan}}元</div>
							</div>
							<div :class="flag==5?'active':'price'" @click="choose(5,yearPrice)" style="width:40%">
								<div>一年</div>
								<div style="margin:25px auto;border-bottom: 1px solid #DCDFE6;font-size: 30px; color: #F56C6C;padding-bottom: 5px;"><span style="font-size: 20px;">￥</span>{{yearPrice}}</div>
								<div style="font-size: 13px; color: #c20d24;">原价：{{yearPriceYuan}}元</div>
							</div>
						</div>
						<div style="font-size: 20px;">应付金额：{{this.price}}元</div>
						<div style="margin: 30px auto;">
							<el-button style="background-color: #31ae37;border-color:#31ae37;color: #fff;" @click="toPay('wechat','wap')"> 
							<img style="display: block;" src="/images/wx.png" width="50px" height="50px"> 
							<span style="display: block;">微信支付</span> </el-button>
							<el-button style="background-color: #24a3de;border-color:#24a3de;color: #fff;" @click="toPay('alipay','wap')">
								<img style="display: block;margin:auto" src="/images/alipay.png" width="50px" height="50px">
								<span style="display: block;">支付宝支付</span> </el-button>
							</el-button>
						</div>
					</div>
				</div>
				
				<div class="mobile-details" v-html="content.content" v-if="(content.permissions == 0 || isLogin) && (isMember || isBuy || content.permissions < 2)"></div>
				<div style="padding-bottom: 50px;">
					<div class="mobile-file" v-if="content.permissions == 0"><a :href="'http://backend.hrl56.com' + content.file">点击下载</a></div>
					<div class="mobile-file" v-else-if="content.permissions == 1 && isLogin"><a :href="'http://backend.hrl56.com' + content.file">点击下载</a></div>
					<div class="mobile-file" v-else-if="content.permissions == 2 && (isMember || isBuy)"><a :href="'http://backend.hrl56.com' + content.file">点击下载</a></div>
					<div class="mobile-file" v-else>您暂无下载权限</div>
					
				</div>
			</el-col>
		</el-row>
	</div>
</template>

<script>
export default {
	// name:'details',
	metaInfo() {
	  return {
		title: this.metaName,
		meta: [
		  { charset: "utf-8" },
		  { name: "keywords", content: this.metaKeywords },
		  { name: "description", content: this.metaDecs },
		],
	  };
	},
  data() {
    return {
		id:0,
		user_id:0,
		isLogin:false,
		isMember:false,
		isBuy:false,
		member:'',
		flag:0,
		price:0,
		articlePrice:0,
		onePrice:0,
		onePriceYuan:0,
		threePrice:0,
		threePriceYuan:0,
		sixPrice:0,
		sixPriceYuan:0,
		yearPrice:0,
		yearPriceYuan:0,
		pay:false,
		payurl:'',
		bannerTop:[],
		bannerMiddle:[],
		sandanlist:[],
		caigoulist:[],
		domain:this.$utils.httpUrl,
		title:"",
		metaName: "",
		metaKeywords: "",
		metaDecs: "",
		loading: false,
		post: null,
		error: null,
		keywords:'',
		value: '',
		content:{},
		loginForm:{
			username:'',
			password:''
		},
		registerForm: {
		  company: '',
		  username: '',
		  nickname:'',
		  duties: '',
		  email: '',
		  mobile: '',
		  password: '',
		  captcha:''
		},
		rules: {
		  company: [
		    { required: true, message: '请输入公司名称', trigger: 'blur' },
		    { min: 2, max: 50, message: '长度在 2 到 50 个字符', trigger: 'blur' }
		  ],
		  username:[
		   { required: true, message: '请输入账号', trigger: 'blur' },
		   {required:true, pattern:/^[a-zA-Z0-9]{3,20}$/ig, message: '长度在 3 到 20 个字母或数字', trigger:'blur'}
		  ],
		  nickname:[
		   { required: true, message: '请输入联系人', trigger: 'blur' },
		   { min: 3, max: 5, message: '长度在 3 到 5 个字符', trigger: 'blur' }
		  ],
		  duties:[
		   { required: true, message: '请输入职务', trigger: 'blur' },
		   { min: 2, max: 5, message: '长度在 2 到 5 个字符', trigger: 'blur' }
		  ],
		  email:[
		   { required: true, message: '请输入邮箱地址', trigger: 'blur' },
		   { type: 'email', message: '请输入正确的邮箱地址', trigger: 'blur' }
		  ],
		  mobile:[
		   { required: true, message: '请输入手机号码', trigger: 'blur' },
		   { min: 11, max: 11, message: '请输入正确的手机号码', trigger: 'blur' }
		  ],
		  password:[
		   { required: true, message: '请输入密码', trigger: 'blur' }
		  ]
		},
		login:false,
		register:false,
		formLabelWidth: '50px',
		registerformLabelWidth: '80px'
	}
  },
  mounted() {
	this.id = this.$route.params.id
	this.getDetails()
	this.$axios({
		url:this.$utils.httpApi + 'index/webconfig'
	}).then(res=>{
		this.title = res.data.data.webtitle
		this.metaDecs = res.data.data.webdescription
		this.metaKeywords = res.data.data.webkeywords
	})
	if(window.localStorage.getItem("token")){
		this.isLogin = true
		this.$axios({
			url:this.$utils.httpApi + 'user/getinfos',
			headers:{
				'token':window.localStorage.getItem("token")
			}
		}).then(res=>{
			if(res.data.type != 0){
				this.isMember = true
				this.member = res.data.type
			}
			
			this.user_id = res.data.id
			this.getBuy(res.data.id)
		})	
	}
	
	
  },
	beforeCreate() {

	},
  created() {
	this.getBanners()
	this.getCaigou()
	this.getZhaobiao()
	this.getPrice()
    // watch 路由的参数，以便再次获取数据
    // this.$watch(
    //   () => this.$route.params,
    //   () => {
    //     this.fetchData()
    //   },
    //   // 组件创建完后获取数据，
    //   // 此时 data 已经被 observed 了
    //   { immediate: true }
    // )
  },
  methods: {
	  memberType(type){
		  if(type == 0){
			  return '普通会员'
		  }else if(type == 1){
			  return '月度会员'
		  }else if(type == 2){
			  return '季度会员'
		  }else if(type == 3){
			  return '半年度会员'
		  }else if(type == 4){
			  return '年度会员'
		  }
	  },
	  getBuy(userid){
		this.$axios({
			url:this.$utils.httpApi + 'details/isbuy',
			data:{'article_id':this.id,'user_id':userid},
			method:'post'
		}).then(res=>{
			if(res.data.code == 1){
				this.isBuy = true
			}
		})  
	  },
	  choose(value,price){
		  this.flag = value
		  this.price = price
	  },
	  getPrice(){
		  this.$axios({
			  url:this.$utils.httpApi + 'details/getPrice'
		  }).then(res=>{
			  let allPrice = res.data.data
			  this.articlePrice = allPrice.articlePrice
			  this.onePrice = allPrice.onePrice
			  this.onePriceYuan = allPrice.onePriceYuan
			  this.threePrice = allPrice.threePrice
			  this.threePriceYuan = allPrice.threePriceYuan
			  this.sixPrice = allPrice.sixPrice
			  this.sixPriceYuan = allPrice.sixPriceYuan
			  this.yearPrice = allPrice.yearPrice
			  this.yearPriceYuan = allPrice.yearPriceYuan 
		  })
	  },
	  toPay(type,meth){
		  if(this.flag == 0){
			  this.$message({
				  message:'请选择会员类型！',
				  type:'error',
				  })
		  }else{
			  let title = '会员充值'
			  if(this.flag == 1){
				  title = this.content.title
			  }
			  this.$axios({
				  method:'post',
				  url:this.$utils.httpApi + 'order',
				  data:{
					  flag:this.flag,
					  article_id:this.id,
					  user_id:this.user_id,
					  price:this.price,
					  title:title,
					  type:type,
					  meth:meth
				  }
			  }).then(res=>{
				  if(type == 'alipay' || meth == 'wap'){
					  this.$router.push({
						  name:'Html',
						  params:{
							  type:type,
							  context:res.data.data
						  },
						  })
				  }else{
					 if(res.data.code == 1){
						  this.pay = true
						  this.payurl=this.domain + '/qrcode/build?text='+ res.data.data.code_url
						  setTimeout(res=>{
							  this.pay = false
						  },30000)
					 }else{
						  this.$message({
							  message:res.data.msg,
							  type:'error'
						  })
					 } 
				  }
			  })
		  }
	  },
	  toLogin(){
		  this.login = false
		  this.$axios({
		  	method:'post',
		  	url:this.$utils.httpApi + 'user/login',
		  	data:this.loginForm
		  }).then(res=>{
		  	if(res.data.code == 1){
		  		window.localStorage.setItem('token',res.data.data.userinfo.token)
				if(res.data.data.userinfo.type != 0){
					this.isMember = true
				}
		  		window.location.reload()
		  		this.isLogin = true
		  		
		  	}else{
		  		this.$message.error(res.data.msg)
		  		
		  	}
		  })
	  },
	  toRegister(formName){
		this.register = false
		this.$refs[formName].validate((valid) => {
		  if (valid) {
		    this.$axios({
				
			   method:'post',
			   url:this.$utils.httpApi + 'user/reg',
			   data:this.registerForm
		    }).then(res=>{
			   if(res.data.code == 0){
				   this.$message.error(res.data.msg);
			   }else{
				   this.$message.success(res.data.msg);
				   window.localStorage.setItem("token", res.data.data.userinfo.token);
				   window.location.reload();
			   }
		    })
		  } else {
			this.$alert('请输入必填项', '提交出错', {
			  confirmButtonText: '确定',
			});
		    return false;
		  }
		});  
	  },
	  type(stat){
	  	if(stat == 0){
	  		return '招标公告'
	  	}else if(stat == 1){
	  		return '散单需求'
	  	} 
	  },
	  status(stat){
	  	if(stat == 2){
	  		return '未开始'
	  	}else if(stat == 3){
	  		return '进行中'
	  	}else if(stat == 4){
	  		return '已结束'
	  	}  
	  },
	  getDetails(){
		this.$axios({
			url:this.$utils.httpApi + 'Details',
			data:{id:this.id},
			method:'post'
		}).then(res=>{
			this.content = res.data.data
			this.metaName = this.content.title + '-' + this.title
		})  
	  },
	  getCaigou(){
	  	this.$axios({
	  		url:this.$utils.httpApi + 'index/getCaigou'
	  	}).then(res=>{
	  		res.data.data.forEach(resp=>{
	  			if(resp.typelist == 0){
	  				this.caigoulist.push(resp)
	  			}
	  		})
	  	})   
	  },
	  getZhaobiao(){
	  	this.$axios({
	  		url:this.$utils.httpApi + 'index/getZhaobiao'
	  	}).then(res=>{
	  		res.data.data.forEach(resp=>{
	  			if(resp.typelist == 1 && resp.status > 2){
	  				this.sandanlist.push(resp)
	  			}
	  		})
	  	})   
	  },
	  getBanners(){
		this.$axios({
			url:this.$utils.httpApi + 'index/getBanner'
		}).then(res=>{
			res.data.data.forEach(resp=>{
				if(resp.type == 4){
					this.bannerTop.push(resp)
				}else if(resp.type == 5){
					this.bannerMiddle.push(resp)
				}
			})
		}) 
	  },
    // fetchData() {
    //   this.error = this.post = null
    //   this.loading = true
    //   // replace `getPost` with your data fetching util / API wrapper
    //   getPost(this.$route.params.id, (err, post) => {
    //     this.loading = false
    //     if (err) {
    //       this.error = err.toString()
    //     } else {
    //       this.post = post
    //     }
    //   })
    // },
	handle(id){
		this.$router.push('/newsdetails/id/'+id)
	}
  },
}
</script>

<style scoped>
	.price{
		width: 20%;
		height:150px;
		border:1px solid #DCDFE6;
		border-radius: 10px;
		margin:20px auto;
		display: flex;
		flex-direction: column;
		justify-items: center;
		justify-content: center;
	}
	.active{
		width: 20%;
		height:150px;
		border:1px solid #c20d24;
		border-radius: 10px;
		margin:20px auto;
		display: flex;
		flex-direction: column;
		justify-items: center;
		justify-content: center;
		position: relative;
	}
	.active:before {
	    content: '√';
	    display: block;
	    position: absolute;
	    width: 24px;
	    height: 24px;
	    background: #c20d24;
	    right: 0px;
	    bottom: 0px;
	    background-size: 30px;
		color: #fff;
		border-left-radius: 5px;
		border-radius-right: 5px;
		border-bottom-right-radius: 5px;
		font-size: 20px;
		border-top-left-radius: 100%;
	}
	.text{
		cursor: pointer;
		color:#409EFF;
	}
	.mobile-title{
		font-size: 1.2rem;
		color:#409EFF;
	}
	.mobile-info{
		font-size: 0.8rem;
		color:#606266;
		margin:10px 0;
	}
	.mobile-time{
		font-size: 0.8rem;
		color:#606266;
		margin:10px 0;
	}
	.mobile-file{
		font-size: 1rem;
		font-weight: 700;
	}
	.mobile-description{
		margin:10px 0;
	}
	.mobile-details{
		margin-bottom: 50px;
	}
	.el-col {
		border-radius: 4px;
	}
	.bg-purple-dark {
		background: #99a9bf;
	}
	.bg-purple {
		background: #d3dce6;
	}
	.bg-purple-light {
		background: #e5e9f2;
	}
	.grid-content {
		border-radius: 4px;
		min-height: 36px;
	}
	.search{
		margin:10px auto;
	}
	.contentList{
		margin-top: 10px;
	}
	.el-carousel__item h3 {
		color: #475669;
		font-size: 18px;
		opacity: 0.75;
		line-height: 300px;
		margin: 0;
	}

	.el-carousel__item:nth-child(2n) {
		background-color: #99a9bf;
	}

	.el-carousel__item:nth-child(2n+1) {
		background-color: #d3dce6;
	}
	.text {
		font-size: 14px;
	}

	.item {
		padding: 18px 0;
	}

	.box-card {
		/* width: 480px; */
	}	
	.listHeader{
		background-color: #409EFF;
		width:100%;
		height:40px;
		color:#fff;
		line-height: 40px;
		text-align: center;
		font-size: 1.1rem;
		font-weight: 700;
		margin-top: 10px;
	}
	.second{
		margin-bottom: 10px;
	}
	.title{
		text-align:center;
		font-size: 1.5rem;
		margin:10px auto;
		color:red;
		border-bottom:1px dashed #DCDFE6;
		padding-bottom: 10px;
	}
	.subtitle{
		margin:10px auto;
		text-align: left;
		color: #909399;
	}
	.subtitle span{
		padding-right: 20px;
	}
	.details{
		margin-top: 20px;
		padding-bottom: 10px;
		border-bottom:1px solid #DCDFE6;
	}
	.tips{
		margin-top: 10px;
		font-size:0.8rem;
		color:#909399;
		
	}
	.tips span{
		color:red;
	}
	td{
		border-right:0.5px solid #DCDFE6;
		border-bottom:0.5px solid #DCDFE6;
		height:50px;
		text-align: center;
	}
	table{
		border-top:0.5px solid #DCDFE6;
		border-left:0.5px solid #DCDFE6;
	}
</style>